import BaseAccountController from '../../lib/controllers/BaseAccountController';
import {IParsedAgreement} from '../../lib/helpers/agreements/agreementParser';
import queryParameterParser from '../../lib/helpers/queryStringParser';
import {IAgreementService} from '../../lib/services/agreementService';

declare var LtFramework: lt.Static;

export default class AgreementsController extends BaseAccountController {
	public static $inject: string[] = ['$q', '$scope', '$window', '$sce', 'agreementService', 'UserResource'];

	public agreementHtml: string;
	public agreementFooter: string;
	public signatureHtml: string;
	public agreementTitle: string;
	public canGoBack: boolean;
	public user: MyAccountApi.IUser;
	public memberId: number;
	public partyId: number;

	private readonly agreementService: IAgreementService;
	private readonly User: MyAccountApi.IUserResource;
	private readonly $window: ng.IWindowService;
	private readonly $sce: ng.ISCEService;
	private readonly $q: ng.IQService;

	constructor($q: ng.IQService, $scope: ng.IScope, $window: ng.IWindowService, $sce: ng.ISCEService,
			agreementService: IAgreementService, User: MyAccountApi.IUserResource) {
		super($scope);
		this.$q = $q;
		this.$window = $window;
		this.$sce = $sce;
		this.canGoBack = $window.history.length > 0;
		this.agreementService = agreementService;
		this.User = User;
	}

	public goBack(): void {
		this.$window.history.back();
	}

	public print(): void {
		this.$window.print();
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		const isSigned = queryParameterParser.getParameterByName(this.$window, 'signed');
		const source = queryParameterParser.getParameterByName(this.$window, 'source') || '';
		const agreementType = queryParameterParser.getParameterByName(this.$window, 'agreementType') || '';
		const agreementId = queryParameterParser.getParameterByName(this.$window, 'agreementId') || '';
		const paymentType = queryParameterParser.getParameterByName(this.$window, 'paymentType') || '';

		this.user = this.User.get();

		this.$q.all([this.user.$promise]).then(() => {
			// check if user is a member
			if (this.user.memberContext && this.user.memberContext.memberId) {
				this.memberId = this.user.memberContext.memberId;
				this.agreementService.getAgreement(this.memberId, this.partyId, parseInt(agreementId, 0), source, agreementType, paymentType, !!isSigned)
					.then((parsedAgreement: IParsedAgreement) => {
						this.populateHtml(parsedAgreement, !!isSigned);
					});
			} else {
				// non-member user
				this.partyId = this.user.partyId;
				this.agreementService.getAgreement(undefined, this.partyId, parseInt(agreementId, 0), source, agreementType, paymentType, !!isSigned)
					.then((parsedAgreement: IParsedAgreement) => {
						this.populateHtml(parsedAgreement, !!isSigned);
					});
			}
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private populateHtml(parsedAgreement: IParsedAgreement, isSigned: boolean): void {
		if (isSigned) {
			this.signatureHtml = this.$sce.trustAsHtml(parsedAgreement.signature);
		}

		this.agreementTitle = parsedAgreement.title;
		this.agreementHtml = this.$sce.trustAsHtml(parsedAgreement.body);
		this.agreementFooter = this.$sce.trustAsHtml(parsedAgreement.footer);
	}
}
